import { FieldNameEnum } from '@goldcast/api/backend';

import { State } from './types';
import { getFormattedEventDateFromUTC } from '../registrants/utils';

import { MultiselectItem } from '@/studioComponents/StudioMultiselect.vue';

const getters = {
  getSelectedColumnsFilters: (state: State): Record<FieldNameEnum, MultiselectItem[]> | {} => {
    const uniqueColumnFilters = state.uniqueColumnFilters;
    const selectedColumnsFilters = {};

    Object.keys(uniqueColumnFilters).forEach(columnKey => {
      const selectedColFilters = uniqueColumnFilters[columnKey].filter(filter => filter.selected);

      if (selectedColFilters.length) {
        selectedColumnsFilters[columnKey] = selectedColFilters;
      }
    });

    return selectedColumnsFilters;
  },
  getSelectedColumnFilterTitles:
    (state: State) =>
    ({ columnKey, isRepeatingEvent = false }: { columnKey: FieldNameEnum; isRepeatingEvent?: boolean }): string => {
      const uniqueColumnFilters = state.uniqueColumnFilters;

      const selectedColumnFilterItems = (uniqueColumnFilters[columnKey] || []).filter(filter => filter.selected);
      const selectedColumnFilterTitles =
        selectedColumnFilterItems.map(filter => {
          if (isRepeatingEvent && columnKey === 'events') {
            return getFormattedEventDateFromUTC(filter.title as string);
          }

          return filter.title;
        }) || [];
      return selectedColumnFilterTitles.join(',');
    },
  getFilteredUniqueColumnFilters: (state: State): Record<FieldNameEnum, MultiselectItem[]> | {} => {
    const { uniqueColumnFilters, columnsFiltersSearchTerms } = state;
    const filteredUniqueColumnFilters = {};

    Object.keys(uniqueColumnFilters).forEach((key: string) => {
      const searchTerm = columnsFiltersSearchTerms[key] || '';
      const filteredColumnFilters = uniqueColumnFilters[key].filter(value => {
        return typeof value?.title === 'string' && value?.title?.toLowerCase().includes(searchTerm.toLowerCase());
      });

      filteredUniqueColumnFilters[key] = filteredColumnFilters;
    });

    return filteredUniqueColumnFilters;
  }
};

export default getters;
